// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-action-template/src/index.tsx

// TODO: Check if the icon is alined properly.
// If it is not: Replace/extend defaultAlignedActionIconGroupProps to make it look right.
// https://stash.int.klarna.net/projects/UI/repos/bubble-ui/pull-requests/121/overview?commentId=2244923
import baseIcon, { defaultAlignedActionIconGroupProps } from '@bubble-ui/temp-icon-base';
var ActionIconLikePath = 'M7.5 0c1.745 0 2.046.982 2 2a5.223 5.223 0 0 1-.379 1.719L9 4h1.5c1 0 1.539.948 1.5 2a4.262 4.262 0 0 1-.095.64l-.079.35-.1.391-.058.208-.13.434-.071.224-.156.457-.172.461c-.537 1.38-1.266 2.69-2.014 2.824L9 12H0V4h2l3-4h2.5ZM3 6H2v4h6.501l.06-.086c.17-.26.357-.622.542-1.053l.093-.221c.146-.358.284-.75.404-1.122l.133-.436.112-.398a7.27 7.27 0 0 0 .138-.606L9.994 6H5.872l1.313-2.84a3.38 3.38 0 0 0 .3-1.043L7.496 2H6L3 6Z';
var ActionIconLike = baseIcon('ActionIconLike', {
  groupProps: defaultAlignedActionIconGroupProps,
  getPath: () => ActionIconLikePath
});
export default ActionIconLike;
//# sourceMappingURL=index.js.map